import { useQuery } from "@tanstack/react-query";

import { GINO_QUERY_KEYS } from "../queryKeys";
import { getOrCreateDirectRoom } from "../services/chat";

export const useGetOrCreateDirectRoom = () => {
  const otherUserId = process.env.REACT_APP_GINO_USER_ID;

  return useQuery({
    queryKey: [...GINO_QUERY_KEYS.DIRECT_CHAT_ROOM, otherUserId],
    queryFn: () => getOrCreateDirectRoom({ otherUserId: Number(otherUserId) }),
    enabled: !!otherUserId,
  });
};
